import {
  Button,
  ErrorMessage,
  HStack,
  Pressable,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import React from 'react';
import { Image } from '@chakra-ui/react';
import { formatTimeFromISOStringWithTZ } from './utils';
import styled from '@emotion/styled';

const Grid = styled('div')`
  width: 100%;
  display: grid;
  gap: 6px;
  grid-auto-rows: 40px;
  grid-template-columns: 1fr 1fr 1fr;
`;

type Props = {
  hostAvatarUrl?: string;
  hostDisplayName?: string;
  hostId?: string;
  isError: boolean;
  isSubmitting: boolean;
  onSelectTime: (time: string) => void;
  selectedHostId?: string;
  selectedTime?: string;
  // ISO string of several time spots
  timeSlots: string[];
  timezone: string;
};

export const MeetingTimePicker = ({
  hostAvatarUrl,
  hostDisplayName,
  hostId,
  isError,
  isSubmitting,
  onSelectTime,
  selectedHostId,
  selectedTime,
  timeSlots,
  timezone,
}: Props) => {
  return (
    <VStack gap={'4px'} w={'100%'}>
      <VStack
        borderColor={'cloud.200'}
        borderWidth={1}
        borderRadius={'8px'}
        padding={'16px'}
        width={'100%'}
      >
        <HStack alignItems={'center'} alignSelf={'flex-start'} mb={3}>
          {hostAvatarUrl && (
            <Image
              alt="care team member profile image"
              ml={2}
              fit="cover"
              rounded={'full'}
              src={hostAvatarUrl}
              boxSize={'24px'}
            />
          )}

          <Text ml={'8px'}>{hostDisplayName}</Text>
        </HStack>

        <Grid>
          {timeSlots.map((timeSlot) => {
            const isSelected =
              selectedHostId === hostId && selectedTime === timeSlot;

            const formattedTimeDisplay = formatTimeFromISOStringWithTZ(
              timeSlot,
              timezone
            );

            return (
              <Pressable key={timeSlot}>
                <Button
                  size="sm"
                  bgColor={isSelected ? 'secondary.200' : 'feather.100'}
                  borderWidth={1}
                  borderColor={isSelected ? 'secondary.200' : 'cloud.200'}
                  disabled={isSelected || isSubmitting}
                  _disabled={{ opacity: 1, cursor: 'default' }}
                  onClick={() => onSelectTime(timeSlot)}
                >
                  <Text
                    color={isSelected ? 'white' : 'secondary.500'}
                    fontWeight={'bold'}
                  >
                    {formattedTimeDisplay}
                  </Text>
                </Button>
              </Pressable>
            );
          })}
        </Grid>

        {isError && (
          <VStack mb={4}>
            <ErrorMessage
              message={
                'An error occurred while creating the appointment. Please try again later.'
              }
            />
          </VStack>
        )}
      </VStack>
    </VStack>
  );
};
